import styles from './PreferencesSettings.module.scss';
import { Fragment, useState } from 'react';
import { Button } from 'src/v2/commonComponents/Button';
import { SVG_SIZE_M } from 'src/constants';
import { Atom, Images, ListMagnifyingGlass } from '@phosphor-icons/react';
import classNames from 'classnames';
import { ImageSettings } from 'src/pages/ManageTasksChatPage/components/SidePanel/components/SideSettingsSections/ImageSettings';
import { ResearcherSection } from 'src/v2/components/LeftSidePanel/components/ResearcherSection';
import { DeepResearchSection } from 'src/v2/components/DeepResearchSection';

enum PreferencesSettingsTabs {
  Image = 'image',
  Researcher = 'researcher',
  DeepResearch = 'deepResearch',
}

const Tabs = [
  {
    value: PreferencesSettingsTabs.Image,
    label: 'Image',
    icon: <Images size={SVG_SIZE_M} />,
    isVisible: true,
  },
  {
    value: PreferencesSettingsTabs.Researcher,
    label: 'Researcher',
    icon: <ListMagnifyingGlass size={SVG_SIZE_M} />,
    isVisible: true,
  },
  {
    value: PreferencesSettingsTabs.DeepResearch,
    label: 'Deep Research',
    icon: <Atom size={SVG_SIZE_M} />,
    isVisible: true,
  },
];

export const PreferencesSettings = () => {
  const [activeTab, setActiveTab] = useState<PreferencesSettingsTabs>(
    PreferencesSettingsTabs.Image,
  );

  const tabContent =
    {
      [PreferencesSettingsTabs.Image]: <ImageSettings />,
      [PreferencesSettingsTabs.Researcher]: <ResearcherSection />,
      [PreferencesSettingsTabs.DeepResearch]: <DeepResearchSection />,
    }[activeTab] || null;

  return (
    <div className={styles.root}>
      <div className={styles.tabsWrapper}>
        {Tabs.map((tab) =>
          tab.isVisible ? (
            <Button
              onClick={() => setActiveTab(tab.value)}
              key={tab.value}
              className={classNames(styles.button, {
                [styles.active]: tab.value === activeTab,
              })}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </Button>
          ) : (
            <Fragment key={tab.value} />
          ),
        )}
      </div>
      {tabContent}
    </div>
  );
};
